import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=52708716&"
import script from "./HomeNews.vue?vue&type=script&lang=js&"
export * from "./HomeNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports